import { render } from "./Skeleton.vue?vue&type=template&id=77e38c30"
import script from "./Skeleton.vue?vue&type=script&lang=js"
export * from "./Skeleton.vue?vue&type=script&lang=js"
script.render = render

export default script